import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import Layout from "@components/layout/Layout";
import DecommissionWorkFlow from "@components/form/meter/decommission/DecommissionWorkflow";
import { useSubscriber } from "@hooks/query/useSubscriber";
import { useLevel0Resource } from "@hooks/query/useLevel0Resource";

const SubscriberDecommissionMeter = () => {
  const { t } = useTranslation();
  const { id: subscriberId = "", level0ResourceId = "" } = useParams();
  const { data: subscriber = {} } = useSubscriber(subscriberId);
  const { data: level0Resource = {} } = useLevel0Resource(level0ResourceId);

  return (
    <Layout
      permissions={[
        "UpdateExtractionPoint",
        "CreateDeclarations",
        "DecommissionMeters",
      ]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: t("common.subscribers"),
          href: "/polestar/subscribers",
        },
        {
          label: subscriber.name,
          href: `/polestar/subscribers/${subscriberId}`,
        },
        {
          label: level0Resource.identifier,
          href: `/polestar/subscribers/${subscriberId}?level0ResourceId=${level0Resource.id}`,
        },
        {
          label: `${t("common.extraction_points")} ${t("common.and")} ${t(
            "common.meters"
          )}`,
          href: `/polestar/subscribers/${subscriber?.id}?level0ResourceId=${level0Resource?.id}&extractionPointId=random`,
        },
        {
          label: t("meter.decommission.title"),
        },
      ]}
      title={t("meter.decommission.title")}
      accountingPeriodLevel1ResourceId={subscriber.level1ResourceId}
    >
      <DecommissionWorkFlow />
    </Layout>
  );
};

export default SubscriberDecommissionMeter;
